<template>
  <div class="side-by-side">
    <Dropdown title="Opções" type="primary" size="small" classIcon="fa-solid fa-chevron-down" right="50"
      :items="optionsConditional" />
    <Modal :title="modalOptions.title" :width="modalOptions.width" v-if="showModal('options')"
      :onHideModal="closeModal">
      <SupplierOrderAccept :supplierOrderId="supplierOrder.id" v-if="modalOptions.name == 'acceptSupplierOrder'" />
      <SupplierOrderProgress :supplierOrderId="supplierOrder.id" v-if="modalOptions.name == 'progressSupplierOrder'" />
      <SupplierOrderReject :supplierOrderId="supplierOrder.id" v-if="modalOptions.name == 'rejectSupplierOrder'" />
      <SupplierOrderArchive :supplierOrder="supplierOrder" v-if="modalOptions.name == 'archiveSupplierOrder'" />
      <div class="select-document" v-show="modalOptions.name == 'selectDocument'"></div>
    </Modal>
    <PrintPreview v-if="showModal('print')" module="Billing" :invoiceId="supplierOrder.id"
      :rentId="supplierOrder.rent != null ? supplierOrder.rent.id : null" />
  </div>
</template>
<script>
import SupplierOrderArchive from './SupplierOrderArchive.vue'

import Dropdown from "@nixweb/nixloc-ui/src/component/forms/Dropdown.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import Confirmation from "@nixweb/nixloc-ui/src/component/shared/Confirmation.vue";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";

import SupplierOrderReject from './SupplierOrderReject.vue'
import SupplierOrderProgress from './SupplierOrderProgress.vue'
import SupplierOrderAccept from './SupplierOrderAccept.vue'
import PrintPreview from "../../adm/document/PrintPreview.vue";

import { mapGetters, mapMutations, mapActions, mapState } from "vuex";

export default {
  name: "DropdownOptionsSupplierOrder",
  props: {
    supplierOrder: Object,
  },
  components: {
    Dropdown,
    Modal,
    Select,
    Confirmation,
    Alert,
    PrintPreview, SupplierOrderAccept, SupplierOrderProgress, SupplierOrderReject, SupplierOrderArchive
  },
  data() {
    return {
      documentId: "",
      modalOptions: {
        name: "",
        title: "",
        width: 0,
      },
      options: [
        {
          title: "Aprovar",
          showByStatus: [1, 3],
          classIcon: "fa-solid fa-circle-check",
          eventName: "acceptSupplierOrder",
          style: "color:#38A169;",
        },
        {
          title: "Orçamento",
          showByStatus: [2, 3],
          classIcon: "fa-sharp fa-solid fa-file-invoice",
          eventName: "progressSupplierOrder",
          style: "color:#4BB4E2;",
        },
        {
          title: "Reprovar",
          showByStatus: [1, 2],
          classIcon: "fa-solid fa-do-not-enter",
          eventName: "rejectSupplierOrder",
          style: "color:red;",
          hr: true,
        },
        {
          title: "Arquivar",
          showByStatus: [1, 2, 3],
          classIcon: "fa-solid fa-box-archive",
          eventName: "archiveSupplierOrder",
          style: "color:#453DB4;",
          hr: true,
        },
        /*  {
            title: "Compartilhar",
            showByStatus: [1, 2, 3],
            classIcon: "fa-sharp fa-regular fa-share-nodes",
            eventName: "printRent",
          },
          */
      ],
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    ...mapState("user", ["userLogged"]),
    ...mapGetters("user", ["hasRule"]),
    optionsConditional() {
      let options = [];
      this.options.forEach((option) => {
        if (option.showByStatus.includes(this.supplierOrder.status)) {
          if (option.title == "Arquivar") {
            option.title = this.supplierOrder.archived ? "Desarquivar" : "Arquivar";
          }
          options.push(option);
        }
      });
      return options;
    },
  },
  methods: {
    ...mapMutations("generic", [
      "addEvent",
      "openModal",
      "hideModal",
      "removeLoading",
    ]),
    back() {
      this.modalOptions = {
        name: "selectDocument",
        title: "Selecione o Documento",
        width: 600,
      };
      this.removeLoading(["back"]);
    },
  },
  watch: {
    event: {
      handler(event) {

        if (event.name == "acceptSupplierOrder") {
          this.modalOptions = {
            name: "acceptSupplierOrder",
            title: "Mudar para Aprovada?",
            width: 500,
          };
          this.openModal("options");
        }

        if (event.name == "progressSupplierOrder") {
          this.modalOptions = {
            name: "progressSupplierOrder",
            title: "Mudar para Orçamento?",
            width: 500,
          };
          this.openModal("options");
        }

        if (event.name == "rejectSupplierOrder") {
          this.modalOptions = {
            name: "rejectSupplierOrder",
            title: "Mudar para Reprovada?",
            width: 500,
          };
          this.openModal("options");
        }

        if (event.name == "archiveSupplierOrder") {
          var title = this.supplierOrder.archived ? "Desarquivar" : "Arquivar";
          this.modalOptions = {
            name: "archiveSupplierOrder",
            title: "Tem certeza que deseja " + title + "?",
            width: 500,
          };
          this.openModal("options");
        }

        if (event.name == "printInvoice") {
          this.openModal("print");
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.select-document {
  min-height: 100px;
}

.icon-close {
  color: red;
}

.icon-warning {
  color: darkorange;
}
</style>